// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3d5K8","overflowing":"ReadFullNote_overflowing__3i3nb"};